import { Component, OnInit } from '@angular/core';
import { TelecomService } from '../../../services/telecom/telecom.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth/auth.service';
import { environment } from 'src/environments/environment';
import { forEachChild } from 'typescript';

@Component({
  selector: 'app-hiMarley-management',
  templateUrl: './hiMarley-management.component.html',
  styleUrls: ['./hiMarley-management.component.css']
})
export class HiMarleyManagementComponent implements OnInit {

  newRow: boolean = false;
  data: Array<any> = [];
  filteredData = [];
  bluePrint = { 'maxCount': 250,'enabled': true };
  formValid: boolean = true;
  lambdaError: boolean = false;
  lambdaMessage: string = '';
  editable: boolean = true;
  hiMarleyShutdownUrl:string = '/hiMarleyShutdown';

  constructor(private formBuilder: FormBuilder, private telecomService: TelecomService, private auth: AuthService,) { }


  form = this.formBuilder.group({
    maxCount: new FormControl('', []),
    openedCases: new FormControl('', []),
    closedCases: new FormControl('', []),
    activeCases: new FormControl('', [Validators.required]),
  });
  ngOnInit() {
    this.getHiMarleyStatus();
    this.lambdaError = false;
    this.lambdaMessage = '';
  }

  getHiMarleyStatus() {
    this.telecomService.getRows(environment.hiMarleyCapacityLambdaName).then((data: any) => {
      console.log(data)
      let created = 0, closed = 0, enabled = true, maxCount = 250;
      this.data = data.body.HiMarley.Items;
      this.data.forEach((item: any) => {
        if (item.CaseType === 'open') {
          created += item.Count;
        }
        if (item.CaseType === 'closed') {
          closed += item.Count;
        }
        if (item.CaseType === 'enabled') {
          enabled = item.enabled;
        }
        if (item.CaseType === 'maxCount') {
          maxCount = item.maxCount;
        }
      })
      this.editable = true;
      if(data.statusCode != 200){
        console.log("Error: ", data.Error)
      }
      this.data = [{
        maxCount: maxCount,
        openedCases: created,
        closedCases: closed,
        activeCases: Math.max(0, created - closed),
        enabled: enabled
      }]
    });
  }


  updateMode(gridAction: string) {
    if (gridAction == 'add') {
      this.newRow = true;
    } else if (gridAction == 'edit') {
      this.newRow = false;
    }
  }

  handleButtonClick(event: any) {
    console.log(event);
    this.newRow = false;
    if (event.button == "confirm" || event.button == "delete") {
      this.updateItem(event);
    } else if (event.button == "create") {
      this.newRow = true;
    }
  }

  updateItem(event: any) {
    console.log("Update Item", event);
    let payload;
    let itemToSave = event.item;
    this.lambdaError = false;
    this.lambdaMessage = 'Saving Changes...'
    payload = {
      action: "put",
      item: itemToSave
    }
    this.telecomService.saveRow(payload, environment.hiMarleyCapacityLambdaName).then((data: any) => {
      if (data.statusCode == 200) {
        this.lambdaError = false;
        this.lambdaMessage = "Data saved successfully.";
      } else {
        this.lambdaError = true;
        this.lambdaMessage = data.Error.message;
        console.log(data.Error);
      }
    });
  }


  validateMaxCount(item: any){
    if(item.max == ""){
      item.max = 250;
      console.log('made sure Max Count is not 0');
    }
  }

}

